import { SET_RECOMMENDATIONS, REQUEST_RECOMMENDATIONS } from '../constants';

export const setRecommendations = (data, partNumber, originalOutfit) => {
    const originalOutfitSegment = originalOutfit ? 'originalOutfit' : 'default';
    return {
        type: SET_RECOMMENDATIONS,
        data: { [originalOutfitSegment]: data },
        partNumber,
    };
};

export const requestRecommendations = () => {
    return {
        type: REQUEST_RECOMMENDATIONS,
    };
};
